<template>
    <div>
      <!-- https://material.io/design/color/the-color-system.html#tools-for-picking-colors -->
        <div class="routes-test-wrapper">
            <h2>Routes</h2>
            <ul >
                    <li v-for="item in routes" :key="item.id">
                        <template v-if="item.hasParam">
                          {{  item.linkText }}
                            <router-link tag="a" :to="{name: item.linkName}">{{  item.linkText }}</router-link>
                        </template>
                        <template v-else>
                          {{  item.linkText }}
                            <router-link tag="a" :to="{name: item.linkName}">{{  item.linkText }}</router-link>
                        </template>

                    </li>
            </ul>
        </div>

    </div>
</template>

<script>
export default {
  data() {
    return {
      routes: [
        {
          id: 1,
          linkName: "accueil",
          linkText: "Accueil",
          hasParam: 0,
          param: ""
        },
        { id: 2, linkName: "club", linkText: "Club", hasParam: 0, param: "" },
        { id: 3, linkName: "actus", linkText: "Actus", hasParam: 0, param: "" },
        {
          id: 4,
          linkName: "actuId",
          linkText: "Actu",
          hasParam: 0,
          param: ""
        },
        {
          id: 5,
          linkName: "equipes",
          linkText: "Equipes",
          hasParam: 0,
          param: ""
        },
        {
          id: 6,
          linkName: "equipe",
          linkText: "Equipe",
          hasParam: 0,
          param: ""
        },
        {
          id: 7,
          linkName: "mini-basket",
          linkText: "Mini-Basket",
          hasParam: 0,
          param: ""
        },
        {
          id: 8,
          linkName: "obe",
          linkText: "Operation Basket Ecole",
          hasParam: 0,
          param: ""
        },
        {
          id: 9,
          linkName: "agenda",
          linkText: "Agenda",
          hasParam: 0,
          param: ""
        },
        {
          id: 10,
          linkName: "eventId",
          linkText: "Evenement par Catégorie",
          hasParam: 0,
          param: ""
        },
        {
          id: 11,
          linkName: "sport-sante",
          linkText: "Sport-Santé",
          hasParam: 0,
          param: ""
        },
        {
          id: 12,
          linkName: "sport-ordonnance",
          linkText: "Sport Sur Ordonnance",
          hasParam: 0,
          param: ""
        },
        {
          id: 13,
          linkName: "basket-sante",
          linkText: "Basket Santé",
          hasParam: 0,
          param: ""
        },
        {
          id: 14,
          linkName: "sponsors",
          linkText: "Sponsors",
          hasParam: 0,
          param: ""
        },
        {
          id: 15,
          linkName: "boutique",
          linkText: "Boutique",
          hasParam: 0,
          param: ""
        },
        {
          id: 16,
          linkName: "contact",
          linkText: "Contact",
          hasParam: 0,
          param: ""
        },
        { id: 17, linkName: "root", linkText: "Root", hasParam: 0, param: "" }
      ]
    };
  }
};
</script>

<style lang="scss">
.routes-test-wrapper {
    position: relative;
    display: block;
    background-color: rgba(black, 0.4);
}
</style>



// WEBPACK FOOTER //
// src/components/Routes.vue